"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DotApiEvent = void 0;
/**
 * Emit custom events for the DotCMS Edit Mode
 *
 */
class DotApiEvent {
    emit(params) {
        const { name, data } = params;
        const customEvent = window.top.document.createEvent('CustomEvent');
        customEvent.initCustomEvent('ng-event', false, false, {
            name: name,
            data: data
        });
        window.top.document.dispatchEvent(customEvent);
    }
}
exports.DotApiEvent = DotApiEvent;
